import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function LanguageToggle() {
  const {
    language,
    toggleLanguage
  } = useLanguage();
  return <button onClick={toggleLanguage} className="fixed top-6 right-6 z-50 flex items-center gap-2 bg-barber-dark/90 backdrop-blur-sm border border-barber-gold/30 text-barber-gold px-4 py-2 rounded-full font-oswald font-bold tracking-wider hover:bg-barber-gold hover:text-barber-black transition-all duration-300 shadow-lg" aria-label="Toggle Language" data-id="element-137">
      <Globe size={18} data-id="element-138" />
      <span data-id="element-139">{language === 'es' ? 'EN' : 'ES'}</span>
    </button>;
}